module.exports = __webpack_public_path__ + "img/滑块1.371d5618.jpg";